export class ParentOrganization {
  id = '';

  name = '';
}
